

// export const SCHOOL_COURSE_TYPE_CORSO_AFAM = "AFAM"
// export const SCHOOL_COURSE_TYPE_CORSO_ITS = "ITS"
// export const SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO = "Master_I"
// export const SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO = "Master_II"
export const SCHOOL_COURSE_TYPE_BACHELOR = "Laurea Estero"
export const SCHOOL_COURSE_TYPE_CORSO_AFAM = "Corso AFAM"
export const SCHOOL_COURSE_TYPE_CORSO_ITS = "Corso ITS"
export const SCHOOL_COURSE_TYPE_CORSO_SSML = "Corso SSML"
export const SCHOOL_COURSE_TYPE_CORSO_VOCATIONAL = "Corso Vocational"
export const SCHOOL_COURSE_TYPE_HS = "HS";
export const SCHOOL_COURSE_TYPE_LM = "LM";
export const SCHOOL_COURSE_TYPE_LMCU = "LMCU";
export const SCHOOL_COURSE_TYPE_LMCUE = "LMCUE"
export const SCHOOL_COURSE_TYPE_LT = "LT";
export const SCHOOL_COURSE_TYPE_MASTER_ESTERO = "Master Estero"
export const SCHOOL_COURSE_TYPE_PROP_PRE_MASTER_E_MASTER_ESTERO = "Prop Pre Master E Master Estero"
export const SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO = "Master-I-Livello"
export const SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO = "Master-II-Livello"
export const SCHOOL_COURSE_TYPE_PHD = "PhD"
export const SCHOOL_COURSE_TYPE_SPECIAL = "Scuola-Specializzazione"

export type DegreeType =
    | typeof SCHOOL_COURSE_TYPE_HS
    | typeof SCHOOL_COURSE_TYPE_LT
    | typeof SCHOOL_COURSE_TYPE_LM
    | typeof SCHOOL_COURSE_TYPE_LMCU
    | typeof SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO
    | typeof SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO
    | typeof SCHOOL_COURSE_TYPE_PHD
    | typeof SCHOOL_COURSE_TYPE_BACHELOR
    | typeof SCHOOL_COURSE_TYPE_MASTER_ESTERO
    | typeof SCHOOL_COURSE_TYPE_LMCUE
    | typeof SCHOOL_COURSE_TYPE_CORSO_SSML
    | typeof SCHOOL_COURSE_TYPE_CORSO_AFAM
    | typeof SCHOOL_COURSE_TYPE_CORSO_ITS
    | typeof SCHOOL_COURSE_TYPE_CORSO_VOCATIONAL
    | typeof SCHOOL_COURSE_TYPE_SPECIAL
    | typeof SCHOOL_COURSE_TYPE_PROP_PRE_MASTER_E_MASTER_ESTERO;

export const degreeTypeLabels: Record<DegreeType, string> = {
    [SCHOOL_COURSE_TYPE_HS]: 'Diploma di Maturità',
    [SCHOOL_COURSE_TYPE_LT]: 'Laurea Triennale',
    [SCHOOL_COURSE_TYPE_LM]: 'Laurea Magistrale',
    [SCHOOL_COURSE_TYPE_LMCU]: 'Laurea Magistrale a Ciclo Unico',
    [SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO]: 'Master I Livello',
    [SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO]: 'Master II Livello',
    [SCHOOL_COURSE_TYPE_PHD]: 'PhD',
    [SCHOOL_COURSE_TYPE_BACHELOR]: 'Laurea Estero',
    [SCHOOL_COURSE_TYPE_MASTER_ESTERO]: 'Master Estero',
    [SCHOOL_COURSE_TYPE_LMCUE]: 'LMCUE',
    [SCHOOL_COURSE_TYPE_CORSO_SSML]: 'Corso SSML',
    [SCHOOL_COURSE_TYPE_CORSO_AFAM]: 'Corso AFAM',
    [SCHOOL_COURSE_TYPE_CORSO_ITS]: 'Corso ITS',
    [SCHOOL_COURSE_TYPE_CORSO_VOCATIONAL]: 'Corso Vocational',
    [SCHOOL_COURSE_TYPE_SPECIAL]: 'Scuola di Specializzazione',
    [SCHOOL_COURSE_TYPE_PROP_PRE_MASTER_E_MASTER_ESTERO]: 'Prop Pre Master E Master Estero',
};

export const degreeTypeLabelsWithArticles: Record<DegreeType, string> = {
    [SCHOOL_COURSE_TYPE_HS]: `del ${degreeTypeLabels[SCHOOL_COURSE_TYPE_HS]}`,
    [SCHOOL_COURSE_TYPE_LT]: `della ${degreeTypeLabels[SCHOOL_COURSE_TYPE_LT]}`,
    [SCHOOL_COURSE_TYPE_LM]: `della ${degreeTypeLabels[SCHOOL_COURSE_TYPE_LM]}`,
    [SCHOOL_COURSE_TYPE_LMCU]: `della ${degreeTypeLabels[SCHOOL_COURSE_TYPE_LMCU]}`,
    [SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO]: `del ${degreeTypeLabels[SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO]}`,
    [SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO]: `del ${degreeTypeLabels[SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO]}`,
    [SCHOOL_COURSE_TYPE_PHD]: `del ${degreeTypeLabels[SCHOOL_COURSE_TYPE_PHD]}`,
    [SCHOOL_COURSE_TYPE_BACHELOR]: `della ${degreeTypeLabels[SCHOOL_COURSE_TYPE_BACHELOR]}`,
    [SCHOOL_COURSE_TYPE_MASTER_ESTERO]: `della ${degreeTypeLabels[SCHOOL_COURSE_TYPE_MASTER_ESTERO]}`,
    [SCHOOL_COURSE_TYPE_LMCUE]: `del ${degreeTypeLabels[SCHOOL_COURSE_TYPE_LMCUE]}`,
    [SCHOOL_COURSE_TYPE_CORSO_SSML]: `del ${degreeTypeLabels[SCHOOL_COURSE_TYPE_CORSO_SSML]}`,
    [SCHOOL_COURSE_TYPE_CORSO_AFAM]: `del ${degreeTypeLabels[SCHOOL_COURSE_TYPE_CORSO_AFAM]}`,
    [SCHOOL_COURSE_TYPE_CORSO_ITS]: `del ${degreeTypeLabels[SCHOOL_COURSE_TYPE_CORSO_ITS]}`,
    [SCHOOL_COURSE_TYPE_CORSO_VOCATIONAL]: `${degreeTypeLabels[SCHOOL_COURSE_TYPE_CORSO_VOCATIONAL]}`,
    [SCHOOL_COURSE_TYPE_SPECIAL]: `della ${degreeTypeLabels[SCHOOL_COURSE_TYPE_SPECIAL]}`,
    [SCHOOL_COURSE_TYPE_PROP_PRE_MASTER_E_MASTER_ESTERO]: `del ${degreeTypeLabels[SCHOOL_COURSE_TYPE_PROP_PRE_MASTER_E_MASTER_ESTERO]}`,
};

export const degreeTypeKebabLabels: Record<string, string> = {
    [SCHOOL_COURSE_TYPE_HS.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Diploma di Maturità',
    [SCHOOL_COURSE_TYPE_LT.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Laurea Triennale',
    [SCHOOL_COURSE_TYPE_LM.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Laurea Magistrale',
    [SCHOOL_COURSE_TYPE_LMCU.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Laurea Magistrale a Ciclo Unico',
    [SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Master I Livello',
    [SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Master II Livello',
    [SCHOOL_COURSE_TYPE_PHD.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'PhD',
    [SCHOOL_COURSE_TYPE_BACHELOR.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Laurea Estero',
    [SCHOOL_COURSE_TYPE_MASTER_ESTERO.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Master Estero',
    [SCHOOL_COURSE_TYPE_LMCUE.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'LMCUE',
    [SCHOOL_COURSE_TYPE_CORSO_SSML.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Corso SSML',
    [SCHOOL_COURSE_TYPE_CORSO_AFAM.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Corso AFAM',
    [SCHOOL_COURSE_TYPE_CORSO_ITS.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Corso ITS',
    [SCHOOL_COURSE_TYPE_CORSO_VOCATIONAL.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Corso Vocational',
    [SCHOOL_COURSE_TYPE_SPECIAL.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Scuola di Specializzazione',
    [SCHOOL_COURSE_TYPE_PROP_PRE_MASTER_E_MASTER_ESTERO.toUpperCase().replaceAll("-", "_").replaceAll(" ", "_")]: 'Prop Pre Master E Master Estero',
};

export const registrationYearOptionsFromDegreeType: Record<DegreeType, { min: number, max: number } | undefined> = {
    [SCHOOL_COURSE_TYPE_BACHELOR]: { min: 0, max: 4 },
    [SCHOOL_COURSE_TYPE_CORSO_AFAM]: undefined,
    [SCHOOL_COURSE_TYPE_CORSO_ITS]: { min: 0, max: 2 },
    [SCHOOL_COURSE_TYPE_CORSO_SSML]: undefined,
    [SCHOOL_COURSE_TYPE_CORSO_VOCATIONAL]: { min: 0, max: 2 },
    [SCHOOL_COURSE_TYPE_HS]: undefined,
    [SCHOOL_COURSE_TYPE_LM]: { min: 0, max: 2 },
    [SCHOOL_COURSE_TYPE_LMCU]: { min: 0, max: 6 },
    [SCHOOL_COURSE_TYPE_LMCUE]: { min: 0, max: 6 },
    [SCHOOL_COURSE_TYPE_LT]: { min: 0, max: 3 },
    [SCHOOL_COURSE_TYPE_MASTER_ESTERO]: { min: 0, max: 2 },
    [SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO]: { min: 0, max: 2 },
    [SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO]: { min: 0, max: 2 },
    [SCHOOL_COURSE_TYPE_PHD]: { min: 0, max: 4 },
    [SCHOOL_COURSE_TYPE_SPECIAL]: { min: 0, max: 5 },
    [SCHOOL_COURSE_TYPE_PROP_PRE_MASTER_E_MASTER_ESTERO]: { min: 0, max: 3 },
}

export function degreeLabelToCode(label: string): DegreeType | undefined {
    const pools = [degreeTypeLabels, degreeTypeLabelsWithArticles];

    for (const pool of pools) {
        const match = (Object.entries(pool) as Array<[DegreeType, string]>)
            .find(([, v]) => v.trim().toLowerCase() === label.trim().toLowerCase());
        if (match) return match[0];
    }
    return undefined;
}

export interface FetchSchoolCourseTypesParam {
    page: number,
    per_page: number
    query_search: string
}

export interface SchoolCourseTypeResource {
    id: string
    name: string
}

export interface SchoolCourseTypesResource {
    school_course_types: SchoolCourseTypeResource[];
    page: number;
    total_count: number;
}